import React, { useState } from 'react';
import './ScheduleForm.css';

const daysOfWeek = [
  { value: 0, label: 'Lunes' },
  { value: 1, label: 'Martes' },
  { value: 2, label: 'Miércoles' },
  { value: 3, label: 'Jueves' },
  { value: 4, label: 'Viernes' },
  { value: 5, label: 'Sábado' },
  { value: 6, label: 'Domingo' },
];

const formatTimeForInput = (timeString) => {
  if (!timeString) return '';
  if (typeof timeString === 'string' && timeString.includes(':')) {
    const parts = timeString.split(':');
    return `${parts[0].padStart(2, '0')}:${parts[1] ? parts[1].padStart(2, '0') : '00'}`;
  }
  return timeString;
};

let rowCounter = 0;
const makeRow = (start = '', end = '') => ({ id: ++rowCounter, start_time: start, end_time: end });

const ScheduleForm = ({ initialData, onSubmit, onCancel, isLoading }) => {
  const isEditing = !!(initialData?.id);
  const dayNumber = initialData?.day_of_week ?? 0;
  const dayLabel = daysOfWeek.find(d => d.value === dayNumber)?.label || 'Lunes';

  const [rows, setRows] = useState(() =>
    isEditing
      ? [makeRow(formatTimeForInput(initialData.start_time), formatTimeForInput(initialData.end_time))]
      : [makeRow()]
  );
  const [fieldErrors, setFieldErrors] = useState({});

  const updateRow = (id, field, value) => {
    setRows(prev => prev.map(r => r.id === id ? { ...r, [field]: value } : r));
    setFieldErrors(prev => { const n = { ...prev }; delete n[`${id}.${field}`]; return n; });
  };

  const addRow = () => {
    const last = rows[rows.length - 1];
    setRows(prev => [...prev, makeRow(last.end_time || '')]);
  };

  const removeRow = (id) => {
    setRows(prev => prev.filter(r => r.id !== id));
    setFieldErrors(prev => {
      const n = { ...prev };
      Object.keys(n).filter(k => k.startsWith(`${id}.`)).forEach(k => delete n[k]);
      return n;
    });
  };

  const validate = () => {
    const errs = {};
    rows.forEach(row => {
      if (!row.start_time) errs[`${row.id}.start_time`] = 'Obligatorio';
      if (!row.end_time) errs[`${row.id}.end_time`] = 'Obligatorio';
      else if (row.end_time <= row.start_time) errs[`${row.id}.end_time`] = 'Fin debe ser mayor al inicio';
    });
    for (let i = 0; i < rows.length; i++) {
      for (let j = i + 1; j < rows.length; j++) {
        const a = rows[i], b = rows[j];
        if (a.start_time && a.end_time && b.start_time && b.end_time) {
          if (a.start_time < b.end_time && a.end_time > b.start_time) {
            errs[`${b.id}.start_time`] = `Se superpone con la fila ${i + 1}`;
          }
        }
      }
    }
    setFieldErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    const data = rows.map(r => ({ day_of_week: dayNumber, start_time: r.start_time, end_time: r.end_time }));
    onSubmit(isEditing ? data[0] : data);
  };

  return (
    <form onSubmit={handleSubmit} className="schedule-form">

      <div className="day-info-badge">
        <span className="day-info-label">Día</span>
        <span className="day-info-value">{dayLabel}</span>
      </div>

      <div className="time-rows">
        {rows.map((row, index) => (
          <div key={row.id} className="time-row">
            <div className="time-field">
              {index === 0 && <label>Hora inicio *</label>}
              <input
                type="time"
                value={row.start_time}
                onChange={e => updateRow(row.id, 'start_time', e.target.value)}
                className={fieldErrors[`${row.id}.start_time`] ? 'input-error' : ''}
                step="60"
              />
              {fieldErrors[`${row.id}.start_time`] && (
                <span className="error-message">{fieldErrors[`${row.id}.start_time`]}</span>
              )}
            </div>

            <span className={`time-arrow${index > 0 ? ' no-label' : ''}`}>→</span>

            <div className="time-field">
              {index === 0 && <label>Hora fin *</label>}
              <input
                type="time"
                value={row.end_time}
                onChange={e => updateRow(row.id, 'end_time', e.target.value)}
                className={fieldErrors[`${row.id}.end_time`] ? 'input-error' : ''}
                step="60"
              />
              {fieldErrors[`${row.id}.end_time`] && (
                <span className="error-message">{fieldErrors[`${row.id}.end_time`]}</span>
              )}
            </div>

            {!isEditing && rows.length > 1 && (
              <button
                type="button"
                className={`btn-row-remove${index > 0 ? ' no-label' : ''}`}
                onClick={() => removeRow(row.id)}
                title="Quitar esta franja"
              >
                ×
              </button>
            )}
          </div>
        ))}
      </div>

      {!isEditing && (
        <button type="button" className="btn-add-row" onClick={addRow} disabled={isLoading}>
          + Agregar otra franja horaria
        </button>
      )}

      <div className="form-actions">
        <button type="button" className="btn-sf-cancel" onClick={onCancel} disabled={isLoading}>
          Cancelar
        </button>
        <button type="submit" className="btn-sf-save" disabled={isLoading}>
          {isLoading
            ? 'Guardando...'
            : isEditing
              ? 'Actualizar'
              : rows.length > 1 ? `Guardar ${rows.length} horarios` : 'Guardar horario'}
        </button>
      </div>
    </form>
  );
};

export default ScheduleForm;

